<script>
    import {mapState, mapActions, mapGetters} from 'vuex';
    import CardLimitMixin from "../../../author/pagesbuilder/mixins/CardLimitMixin";
    import SliderMixin from "../../../author/pagesbuilder/mixins/SliderMixin";
    import AnimationsMixin from "../../../author/pagesbuilder/mixins/AnimationsMixin";
    import RowsMixin from "../../../author/pagesbuilder/mixins/RowsMixin";
    

    export default {
        name: "DailyNewsCardsComponent",
        data () {
            return {
                componentType: "daily-news-cards",
                currentRenderData: {}
            }
        },
        mixins: [
            CardLimitMixin,
            SliderMixin,
            RowsMixin,
            AnimationsMixin
        ],    
        computed: {
            ...mapState('common',[
                'articles',
                'articlesLoading',
                'articlesLoaded',
            ]),
            ...mapGetters('user', [
                'isAdmin',
            ]),
            availableCards () {
                return [
                    {
                        cardFilename : "dailynewscard1",
                        forSectionTemplate: "DailyNews1",
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/dailyNewscard1.jpg"
                    },
                    {
                        cardFilename : "dailynewscard2",
                        forSectionTemplate: "DailyNews2",
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/dailyNewscard2.jpg"
                    },
                    {
                        cardFilename : "dailynewscard3",
                        forSectionTemplate: "DailyNews3",
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/dailyNewscard3.jpg"
                    },
                    {
                        cardFilename : "dailynewscard4",
                        forSectionTemplate: "DailyNews4",
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/dailyNewscard4.jpg"
                    },
                    {
                        cardFilename : "dailynewscard5",
                        forSectionTemplate: "DailyNews5",
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/dailyNewscard5.jpg"
                    }
                ]
            },
            getActionTriggerComponentsData () {
                return [
                    {
                        label : this.translations.load_more,
                        display: this.currentRenderData.data && (this.currentRenderData.rows * this.currentRenderData.cardsPerRow < this.currentRenderData.data.length),
                        template: "load-more",
                        executableFunction : this.loadMoreClicked
                    },
                    {
                        label : this.translations.see_all,
                        display: true,
                        template: "see-all",
                        executableFunction : this.seeAllClicked
                    },
                ]
            },
            getDefaultCardType () {
                let sectionState = this.findNodeState(this.sectionId);
                let sectionTemplateId = sectionState.sectionTemplateId;
                let cardTypeData = this.availableCards.find(cardData => sectionTemplateId === cardData.forSectionTemplate);

                if (sectionState && cardTypeData) {
                    return cardTypeData.cardFilename;
                }

                return this.availableCards[0] ? this.availableCards[0].cardFilename : "";
            },
            getDefaultDataStructure () {
                return {
                    componentType: this.componentType,
                    componentId: this.componentId,
                    template: 'basicComponentTemplate',
                    cardType: this.getDefaultCardType,
                    styles: null,
                    rows: 1, // this is the currentPage. increments on every click of load more
                    cardsPerRow: 3, // how many cards will load on each page
                    limitAmountOfCards: true, // flag that enables pagination on cards rendering
                    cardsLoadOption: 'load-more',
                    itemVisibilitySettings: null
                }
            },
            translations () {
                return {
                    "load_more" : this.$t('blog.load_more'),
                    "see_all" : this.$t('blog.see_all'),
                }
            },

        },
        methods: {
            ...mapActions('common', [
                'getArticles'
            ]),
            loadMoreClicked () {

            },
            seeAllClicked () {

            },
            handleActionTrigger (componentName) {
                this.getActionTriggerComponentsData.find( data => {
                    if(data.template === componentName && data.executableFunction) {
                        data.executableFunction.call(null);
                        return true;
                    }
                })
            },
            editArticlesData (articlesData) {
                let newData = copyJson(articlesData);

                newData.filter(article => {

                    let date = new Date(article.published.replace(" ","T"));
                    //let defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');

                    article.date = `${this.i18n.formatTimestampLocalized(date.getTime(), "MMM")} ${date.getDay()} ${date.getFullYear()} `;
                    article.shortDate = `${this.i18n.formatTimestampLocalized(date.getTime(), "MMM")} ${date.getDay()}`;

                    if (article.image && article.image.src) {
                        article.fullImagePath =  article.image.src;
                    } else {
                        article.fullImagePath =  this.imagePath + "/images/default_blog-post_image.jpg";
                    }

                    return article;
                });

                if (this.componentData.applyFilter && this.componentData.filter) {


                    switch (this.componentData.filter) {
                        case "byCustomList":
                            newData = this.filterByCustomList(newData);
                            break;

                    }
                }

                return newData;
            },
            filterByCustomList (articlesData) {

                articlesData = articlesData.filter(article => {
                    if (this.componentData.customListIds.indexOf(article.id) > -1) {
                        return article;
                    }
                });

                return articlesData;
            },         
            renderArticles(articles){
                articles = this.editArticlesData(articles);
                let amountOfCards = articles.length;

                let cardsPerPage = (this.componentData.cardsPerRow > amountOfCards || !this.componentData.limitAmountOfCards) ? amountOfCards : this.componentData.cardsPerRow;

                let renderData = {
                    ...this.componentData,
                    data: articles,
                    cardsPerRow: cardsPerPage,
                    amountOfCards,
                }

                if (articles.length < 1) {
                    renderData.template = 'nocontentmessage';
                    renderData.data = {
                        content: "No Articles found.",
                    }

                    if (this.isAdmin) {
                        renderData.template = 'nocontentmessage_author_dailynewscards';
                        renderData.data.placeholderImageUrl = '/images/placeholders/news.jpg';
                    }
                }

                this.currentRenderData = renderData;



                this.renderTemplate(renderData.template, renderData).then(output => {
                    this.componentNode.innerHTML = output;
                    this.renderingCompleted(renderData);
                    this.handleSliderCreation(renderData);
                    this.addListeners()
                });
                
            },
            renderComponent () {
                this.renderInProgress = true;
                this.prepareDataToRender().then( articles => { this.renderArticles(articles) });
            },
            prepareDataToRender(){
                
                if(!this.articlesLoading && !this.articlesLoaded){
                    return this.getArticles();
                }

                return new Promise((resolve, reject) => {
                    resolve(this.articles);
                })
            },
            addListeners() {}
        },
        watch : {
            "myData.cardType": {
                handler (newVal, oldVal){
                    // console.log(" 1 cardType newVal, oldVal: " , newVal, oldVal , this.myId)
                    if (newVal !== oldVal && !this.renderInProgress) {
                        this.debouncedRenderComponent();
                    }
                }
            },
            "myData.cardsPerRow": {
                handler (newVal, oldVal){
                    // console.log("3 cardsPerRow newVal, oldVal: " , newVal, oldVal  , this.myId)
                    if (newVal !== oldVal && !this.renderInProgress) {
                        this.debouncedRenderComponent();
                    }

                }
            },
            "myData.rows": {
                handler (newVal, oldVal){
                    // console.log("4 rows newVal, oldVal: " , newVal, oldVal  , this.myId)
                    if (newVal !== oldVal && !this.renderInProgress) {
                        this.debouncedRenderComponent();
                    }

                }
            },
            "myData.cardsLoadOption": {
                handler (newVal, oldVal){
                    if (newVal !== oldVal) {
                        this.debouncedRenderComponent();
                    }
                }
            },
            "articles" : {
                deep: true,
                handler () {
                    this.debouncedRenderComponent();
                }
            }
        },
    }
</script>
